import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=10f78738&scoped=true&"
import script from "./gift.vue?vue&type=script&lang=js&"
export * from "./gift.vue?vue&type=script&lang=js&"
import style0 from "./gift.vue?vue&type=style&index=0&id=10f78738&lang=scss&scoped=true&"
import style1 from "./gift.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f78738",
  null
  
)

export default component.exports